import { memo } from 'react';

import AIModelIconSVG from '@/assets/ai-model-icon.svg?react';
import { ComponentContextProps, merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type AIModelLogoProps = LogoProps & Partial<ComponentContextProps>;

const IAIModelLogo = ({ variant, className, ...rest }: AIModelLogoProps) => {
  return (
    <Logo
      variant={variant}
      className={merge(
        'to-primary-600 border-primary-500 border-1 bg-linear-to-r from-[#37beef] text-white',
        className
      )}
      {...rest}
    >
      <AIModelIconSVG />
    </Logo>
  );
};

export const AIModelLogo = memo(IAIModelLogo) as typeof IAIModelLogo;
